import React, { useState } from "react";
import { Form, Button, Alert } from "react-bootstrap";
import axiosClient from "../../../api/axiosClient";

const ManualReportsTab = ({ userId }) => {
  const [file, setFile] = useState(null);
  const [reportType, setReportType] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const uploadReport = async () => {
    setError("");
    setSuccessMessage("");

    if (!userId) {
      setError("Missing User ID.");
      return;
    }

    if (!file) {
      setError("Please select a file.");
      return;
    }

    if (!reportType) {
      setError("Please select a Report Type.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("report_type", reportType);

    try {
      await axiosClient.post(`/manual-reports/${userId}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setSuccessMessage("Report uploaded successfully!");
      setFile(null);
      setReportType("");
    } catch (err) {
      console.error(err);
      setError("Upload failed. Please try again.");
    }
  };

  const isUploadDisabled = !file || !reportType;

  return (
    <div>
      <h5>Manual Report Upload</h5>

      {error && <Alert variant="danger">{error}</Alert>}
      {successMessage && <Alert variant="success">{successMessage}</Alert>}

        {/* Report Type Selection */}
      <Form.Group className="mb-3">
        <Form.Label>Report Type</Form.Label>
        <Form.Select
          value={reportType}
          onChange={(e) => setReportType(e.target.value)}
        >
          <option value="">-- Select Report Type --</option>
          <option value="consumption_by_medicine">
            Consumption Report by Medicine
          </option>
          <option value="consumption_by_patient_served">
            Consumption Report by Patient Served
          </option>
        </Form.Select>
      </Form.Group>

      {/* File Upload */}
      <Form.Group className="mb-3">
        <Form.Label>Select Excel File</Form.Label>
        <Form.Control
          type="file"
          accept=".xlsx,.xls,.csv"
          onChange={(e) => setFile(e.target.files[0])}
        />
      </Form.Group>

      <Button disabled={isUploadDisabled} onClick={uploadReport}>
        Upload
      </Button>
    </div>
  );
};

export default ManualReportsTab;
